import { NavigationModal } from '@lmc/ui-kit'
import { Text } from '@lmc/ui-kit/src/general'
import { Input } from 'antd'
import { useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'

type DeletingTeamMemberModalProps = {
  showModal: boolean
  onCancel: () => void
  onConfirm: () => void
  name: string
  carerId: string
}

const DeletingTeamMemberModal = ({
  showModal,
  onCancel,
  onConfirm,
  name
}: DeletingTeamMemberModalProps) => {
  const { t } = useTranslation()

  const [inputText, setInputText] = useState('')
  const [matchedInput, setMatchedInput] = useState(false)

  const handleConfirm = () => {
    onConfirm()
  }

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputText(e.target.value)
    setMatchedInput(e.target.value === name)
  }

  return (
    <NavigationModal
      modalTitle={t('DELETE_PROFILE_TITLE')}
      modalConfirmText={t('DELETE_PROFILE')}
      modalCancelText={t('CANCEL')}
      showPrompt={showModal}
      confirmNavigation={handleConfirm}
      cancelNavigation={onCancel}
      confirmButtonProps={{
        variant: matchedInput ? 'danger' : 'default',
        disabled: !matchedInput
      }}
    >
      <Text>
        <Trans
          i18nKey="DELETE_TM_DESCRIPTION"
          values={{ name }}
          components={{ strong: <strong /> }}
        />
      </Text>
      <Text>{t('DELETE_TM_EXTRA')}</Text>
      <Input placeholder={name} value={inputText} onChange={handleChange} />
    </NavigationModal>
  )
}

export default DeletingTeamMemberModal
